import { Component, OnInit, EventEmitter } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
import { CategoryMoneyService } from '../../../_services/category-money.service';
import { CategoryMoneyModel } from '../../../_models/category-money'

@Component({
    selector: 'app-edit-category-money',
    templateUrl: './edit-category-money.component.html',
    styleUrls: ['./edit-category-money.component.css']
})

export class EditCategoryMoneyComponent extends DialogComponent<CategoryMoneyModel, boolean> implements OnInit {

    model: any = {};
    loading = false;
    message: string;
    focusEventEmitter = new EventEmitter<boolean>();
    id: string;
    constructor(
        dialogService: DialogService,
        private categoryMoneyService: CategoryMoneyService) {
        super(dialogService);
    }

    ngOnInit() {
        this.loading = true;
        this.categoryMoneyService.get(this.id).subscribe(data => {
            this.model.name = data.category_name;
        }, error => {
            
        }, () => {
            this.loading = false;
        });
    }

    ngAfterViewInit() {
        this.focusEventEmitter.emit(true);
    }

    edit() {
        this.loading = true;
        this.message = '';
        this.model.id = this.id;
        this.categoryMoneyService.edit(this.model).subscribe(data => {
            if (data.error) {
                this.message = data.message;
            } else {
                this.close();
                this.result = true;
            }
        }, error => {
            this.message = error.json().message;
            this.loading = false;
        }, () => {
            this.loading = false;
        })
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/category-money/edit-category-money/edit-category-money.component.ts